<template>
  <div class="columns is-multiline">
    <div class="column is-12">
      <div
        :style="`margin-left: -${local_multi_chars.styles.margin}px; margin-right: -${local_multi_chars.styles.margin}px;`"
        class="multi-chars-row"
        v-for="(row, row_index) in local_multi_chars.data"
        :key="`ROW-${row_index}`"
      >
        <div
          class="multi-chars-cell"
          v-for="(col, col_index) in row"
          :key="`ROW-${row_index}-COL-${col_index}`"
          :style="cellStyles(local_multi_chars.styles)"
        >
          <div
            class="multi-chars-cell-value"
            :style="
              cellStyles({ text_align: local_multi_chars.styles.text_align })
            "
          >
            <span v-if="col.type == 'T'">{{ col.value }}</span>
            <up-textinput
              v-else-if="is_show_answer && col.type == 'I'"
              :size="col.inp_size"
              :font_size="local_multi_chars.styles.font_size"
              v-model="col.value"
            />
            <up-textinput
              v-else-if="!is_show_answer && col.type == 'I'"
              :size="col.inp_size"
              :font_size="local_multi_chars.styles.font_size"
              v-model="col.response"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCSSFromStyles } from "@/components/Common/StyleEditor/utils";
import UpTextinput from "../../UI/Inputs/UpTextinput.vue";
import { defaultMultiCharsValue } from "./utils";
export default {
  name: "show-multi-chars",
  components: {
    UpTextinput,
  },
  props: {
    multi_chars: {
      type: Object,
    },
    is_show_answer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      local_multi_chars: this.multi_chars
        ? this.multi_chars
        : defaultMultiCharsValue(),
    };
  },
  methods: {
    cellStyles(styles) {
      return getCSSFromStyles(styles);
    },
  },
  watch: {
    multi_chars: {
      handler: function (new_value) {
        this.local_multi_chars = new_value;
      },
      deep: true,
    },
    local_multi_chars: {
      handler: function (new_value) {
        let is_correct = true;
        for (let row of new_value.data) {
          for (let col of row) {
            if (
              col.type == "I" &&
              col.value !== "" &&
              col.value != col.response
            ) {
              is_correct = false;
              break;
            }

            if (!is_correct) {
              break;
            }
          }
        }

        this.$emit("input", is_correct);
      },
      deep: true,
    },
  },
};
</script>

<style src="./styles/index.css"></style>
